import { render, staticRenderFns } from "./ChatConfigurationTab.vue?vue&type=template&id=40554c78&lang=pug&"
import script from "./ChatConfigurationTab.vue?vue&type=script&lang=js&"
export * from "./ChatConfigurationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatConfigurationTab.vue"
export default component.exports